export const GetUserData = (userId, allUser) => allUser?.find(user => user?.userId===userId);